import { render } from "./Element.vue?vue&type=template&id=6e1552e7&scoped=true"
import script from "./Element.vue?vue&type=script&lang=js"
export * from "./Element.vue?vue&type=script&lang=js"

import "./Element.vue?vue&type=style&index=0&id=6e1552e7&scoped=true&lang=css"

import exportComponent from "/home/jacques/development/kvhbf/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e1552e7"]])

export default __exports__